export default function (matchLength: string): number {
  const temp = matchLength.split('*');
  return parseInt(temp[1]);
}
